<template>
  <div>
    <div>
      <div class="col-11 text-right menu-locale">
        <base-button
          size="sm"
          type="primary"
          v-if="this.$i18n.locale == 'en'"
          @click="en()"
          >EN</base-button
        >
        <base-button
          size="sm"
          type="neutral"
          v-if="this.$i18n.locale == 'th'"
          @click="en()"
          >EN</base-button
        >
        <base-button
          size="sm"
          type="primary"
          v-if="this.$i18n.locale == 'th'"
          @click="th()"
          >TH</base-button
        >
        <base-button
          size="sm"
          type="neutral"
          v-if="this.$i18n.locale == 'en'"
          @click="th()"
          >TH</base-button
        >
      </div>
    </div>
    <!-- Header -->
    <div class="header  py-7 py-lg-6 pt-lg-1">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-md-8 px-5">
              <img
                src="img/true_dtac.png"
                alt=""
                style="width:50%;height:auto;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100"></div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5" v-if="state == 'login'">
              <div class="text-center text-muted mb-4">
                <small>{{ $t("auth.signin") }}</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <form :aria-label="$t('auth.signin')" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="Email"
                    error="error"
                    prepend-icon="ni ni-email-83"
                    :placeholder="$t('auth.username')"
                    v-model="model.email"
                    autocomplete="off"
                  >
                  </base-input>

                  <base-input
                    alternative
                    class="mb-3"
                    name="Password"
                    prepend-icon="ni ni-lock-circle-open"
                    type="password"
                    :placeholder="$t('auth.pass')"
                    v-model="model.password"
                    autocomplete="off"
                  >
                  </base-input>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4 btn-info"
                      >{{ $t("auth.signin") }}</base-button
                    >
                  </div>
                  <div class="text-center">
                    <router-link to="/forgotpassword" class="text-light">
                      <base-button type="default" class="btn-info">{{
                        $t("auth.forgetpass")
                      }}</base-button>
                    </router-link>
                  </div>
                </form>
              </validation-observer>
            </div>

            <!-- 2FA -->
            <div class="card-body px-lg-5 py-lg-5" v-if="state == '2fa'">
              <div class="text-left text-muted mb-4">
                <h2>{{ $t("auth.twofa") }}</h2>
                <small>{{ $t("auth.twofa_send_to", [mobileNumber]) }}</small>
              </div>
              <div class="text-center text-red mb-4">
                <small>{{ $t("auth.otp_ref_code", [refCode]) }}</small>
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="form2FAValidator"
              >
                <form :aria-label="$t('auth.otpcode')" @submit.prevent="handleSubmit(onSubmit2FA)">

                  <base-input
                    alternative
                    class="mb-3"
                    name="otpcode"
                    prepend-icon="fa fa-key"
                    :placeholder="$t('auth.otpcode')"
                    v-model="otpCode"
                    autocomplete="off"
                    maxlength="6"
                  >
                  </base-input>

                  <div class="text-left text-muted mb-4" v-if="timerCount != 0">
                    <small>{{ $t("auth.requestnewotp", [timerCount]) }}</small>
                  </div>

                  <!-- if user -->
                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      :disabled="!isOTPValid"
                      class="my-4 btn-info"
                      >{{ $t("auth.signin") }}</base-button
                    >
                  </div>
                </form>

                <div class="text-center" v-if="timerCount == 0">
                  <base-button
                    type="default"
                    class="btn-info text-light"
                    @click="onSubmit"
                    >{{ $t("auth.requestotp") }}</base-button
                  >
                </div>
              </validation-observer>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert2";
const qs = require("querystring");

export default {
  data() {
    return {
      recaptchaKey: process.env.VUE_APP_RECAPTCHA,
      model: {
        email: "",
        password: "",
        rememberMe: false
      },
      refCode: "",
      otpCode: "",
      messageId: "",
      mobileNumber: "",
      timerCount: 0,

      state: "login"
    };
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters({
      getUser: "Auth/getUser",
      getLocale: "Auth/getLocale"
    }),
    isOTPValid: function() {
      let regOtp = new RegExp("\\d{6}");
      return regOtp.test(this.otpCode);
    }
  },
  async mounted() {
    // Locale locale
    this.state = "login";
    this.refCode = "";
    this.otpCode = "";
    this.messageId = "";
    this.$i18n.locale = this.getLocale;
    await this.$recaptchaLoaded();
    const recaptcha = this.$recaptchaInstance;
    recaptcha.showBadge();
    this.$cookie.set("token", "testtoken", { expires: "1D", secure: true });
  },
  methods: {
    ...mapActions({
      setUser: "Auth/setUser",
      setMigration: "Auth/setMigration",
      setLocale: "Auth/setLocale",
      SignIn: "Auth/SignIn"
    }),
    en() {
      this.$i18n.locale = "en";
      this.setLocale("en");
    },
    th() {
      this.$i18n.locale = "th";
      this.setLocale("th");
    },
    async onSubmit() {
      this.token = await this.$recaptcha("login");

      const maintenanceKey = this.$store.getters["Auth/getMaintenanceKey"];
      this.SignIn({
        username: this.model.email,
        password: this.model.password,
        locale: this.$i18n.locale,
        token: this.token,
        maintenance_key: maintenanceKey || ""
      })
        .then(res => {
          this.refCode = res.data.OTP.RefCode;
          this.messageId = res.data.OTP.MessageId;
          this.state = "2fa";
          this.timerCount = 30;
          this.mobileNumber = res.data.OTP.MobilePhone;
        })
        .catch(err => {
          // Maintenance gate: rejected with Msg "errors.auth.maintenance_active" (HTTP 503).
          // Detect FIRST — surrounding TwoFAErrorText/TwoFAErrorCode helpers assume an
          // `error` field that the maintenance response doesn't include, so calling them
          // would throw TypeError and kill this catch before the redirect ran.
          if (
            err.response &&
            err.response.data &&
            err.response.data.Msg === "errors.auth.maintenance_active"
          ) {
            // Wrong / stale key in store → clear it so the user can retry via a fresh
            // /login/maintenance/<key> URL without a manual localStorage wipe.
            this.$store.dispatch("Auth/clearMaintenanceKey");
            this.$router.push("/maintenance");
            return;
          }

          if (err.response.data.message == "Invalid reCAPTCHA") {
            swal.fire({
              title: this.$t("errors.auth.login_fail"),
              size: `sm`,
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });

            return;
          }

          swal.fire({
            title: this.TwoFAErrorText(
              err.response.data.error,
              err.response.data.msg
            ),
            text: this.TwoFAErrorCode(err.response.data.error),
            size: `sm`,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    },
    async onSubmit2FA() {
      this.token = await this.$recaptcha("login");
      const maintenanceKey = this.$store.getters["Auth/getMaintenanceKey"];
      this.SignIn({
        username: this.model.email,
        locale: this.$i18n.locale,
        refCode: this.refCode,
        otpCode: this.otpCode,
        messageId: this.messageId,
        token: this.token,
        maintenance_key: maintenanceKey || ""
      })
        .then(res => {
          // console.log(res)
          if (res.data.Url != "" && res.data.Url != undefined) {
            // console.log("Url",res.data.Url)
            window.location = res.data.Url;
          } else {
            const recaptcha = this.$recaptchaInstance;
            recaptcha.hideBadge();
            // console.log("Token",res.data.Token)
            // console.log("User",res.data.User)
            this.$cookie.set("token", res.data.Token, {
              expires: "1D",
              secure: true
            });
            this.setUser(res.data.User);
            // Stamp the EAS-migration right here and only here (#47). It comes
            // from the API's config.yml allow-list, not the user record, so the
            // login response is the one place that carries it — the profile
            // endpoints deliberately do not.
            this.setMigration(res.data.User.Migration);
            this.$router.push("/portal");
          }
        })
        .catch(err => {
          console.log(err);
          this.otpCode = "";

          // Maintenance gate: rejected with Msg "errors.auth.maintenance_active" (HTTP 503).
          // Detect FIRST — surrounding TwoFAErrorText/TwoFAErrorCode helpers assume an
          // `error` field that the maintenance response doesn't include, so calling them
          // would throw TypeError and kill this catch before the redirect ran.
          if (
            err.response &&
            err.response.data &&
            err.response.data.Msg === "errors.auth.maintenance_active"
          ) {
            // Wrong / stale key in store → clear it so the user can retry via a fresh
            // /login/maintenance/<key> URL without a manual localStorage wipe.
            this.$store.dispatch("Auth/clearMaintenanceKey");
            this.$router.push("/maintenance");
            return;
          }

          if (err.response.data.message == "Invalid reCAPTCHA") {
            swal.fire({
              title: this.$t("errors.auth.login_fail"),
              size: `sm`,
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });

            return;
          }

          swal.fire({
            title: this.TwoFAErrorText(
              err.response.data.error,
              err.response.data.msg
            ),
            text: this.TwoFAErrorCode(err.response.data.error),
            size: `sm`,
            icon: "error",
            confirmButtonClass: "btn btn-danger btn-fill",
            buttonsStyling: false
          });
        });
    }
  }
};
</script>

<style scoped>
.menu-locale {
  padding-top: 0.25in;
}
</style>
